import { LogIn } from 'lucide-react';
import { BrandMark } from '../ui/BrandMark.tsx';
import { useState, type FormEvent } from 'react';
import { useI18n } from '../app/i18n.tsx';
import { useAuth } from '../app/session.tsx';
import { Segmented } from '../ui/primitives.tsx';

export function LoginPage() {
  const { t, language, setLanguage } = useI18n();
  const { auth, state } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(state.status === 'signedOut' && state.message ? t.t('auth.sessionExpired') : null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const result = await auth.signIn(email, password);
    setBusy(false);
    if (!result.ok) setError(result.reason === 'NETWORK' ? t.t('errors.network') : t.t('auth.invalidCredentials'));
  }

  return (
    <div className="auth">
      <form className="card auth__card" onSubmit={submit} noValidate>
        <div className="row gap-3">
          <BrandMark />
          <span className="brand__name">{t.t('app.name')}</span>
          <span className="grow" />
          <Segmented
            label={t.t('settings.language')}
            value={language}
            onChange={setLanguage}
            options={[
              { value: 'pl', label: 'PL' },
              { value: 'en', label: 'EN' },
            ]}
          />
        </div>
        <div className="stack gap-1">
          <h1 className="auth__title">{t.t('auth.signInTitle')}</h1>
          <p className="text-secondary">{t.t('auth.signInSubtitle')}</p>
        </div>
        <label className="field">
          <span className="field__label">{t.t('auth.email')}</span>
          <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="field">
          <span className="field__label">{t.t('auth.password')}</span>
          <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && (
          <p className="field__error" role="alert">
            {error}
          </p>
        )}
        <button className="btn btn--primary btn--lg btn--block" type="submit" disabled={busy || !email || !password}>
          <LogIn aria-hidden="true" />
          {busy ? t.t('auth.signingIn') : t.t('auth.signIn')}
        </button>
      </form>
    </div>
  );
}
